module.exports = __webpack_public_path__ + "img/chrome.5add6e18.png";